module.exports = __webpack_public_path__ + "static/media/Partner4.d8224be2.webp";